import { ODataSelect } from "../../../../Providers.Api/ODataQuery";

export interface IMenuItem
{
    MenuItemId: string;
}

export class CateringTemplate extends ODataSelect
{
    MenuTemplate_Id = "";
    Menu_Id = "";
    Description = "";
    Deleted = false;
    MenuItems: IMenuItem[] = [];
    MinimumBookingDuration = 0;
    Name = "";
    Node_Id = 0;
}

export interface ICateringTemplate
{
    cateringTemplateId: string;
    menuId: string;
    description: string;
    deleted: boolean;
    menuItems: IMenuItem[];
    minimumBookingDuration: number;
    name: string;
    nodeId: number;
    menuName: string;
    menuMenuItems: string;
    costpp: number;
}